import React from "react";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Divider from "@material-ui/core/Divider";

/**
 * Componente para mostrar y gestionar la dirección de envío
 * @param {Object} domicilioSeleccionado - Dirección de envío seleccionada
 * @param {Array} domicilios - Lista de direcciones disponibles
 * @param {Function} onAddNew - Callback para agregar nueva dirección
 * @param {Function} onChange - Callback para cambiar dirección
 */
const ShippingAddress = ({
	domicilioSeleccionado,
	domicilios,
	onAddNew,
	onChange,
}) => {
	const tieneDireccion =
		domicilios.length > 0 &&
		domicilioSeleccionado &&
		Object.keys(domicilioSeleccionado).length > 0;

	return (
		<Card className="carrito-card">
			<CardBody className="carrito-card-body">
				<div className="carrito-card-title-section">
					<h4 className="carrito-card-title">Dirección de envío</h4>
					<Divider />
				</div>
				{tieneDireccion ? (
					<GridContainer>
						<GridItem xs={12} sm={10}>
							<div className="carrito-direccion">
								<div className="direccion-calle">
									{domicilioSeleccionado.Calle}
								</div>
								<div className="direccion-detalle">
									{domicilioSeleccionado.Colonia}, C.P.{" "}
									{domicilioSeleccionado.CodigoPostal}
								</div>
							</div>
						</GridItem>
						<GridItem xs={12} sm={2} style={{ textAlign: "right" }}>
							<Button
								color="transparent"
								onClick={onChange}
								className="carrito-link-button"
							>
								Cambiar
							</Button>
						</GridItem>
					</GridContainer>
				) : (
					<Button
						color="transparent"
						onClick={onAddNew}
						className="carrito-link-button"
					>
						+ Agregar dirección de envío
					</Button>
				)}
			</CardBody>
		</Card>
	);
};

export default ShippingAddress;

